/**
 * Public Website Route Constants
 * Centralized route definitions for the main website
 */

// Public website routes
export const PUBLIC_ROUTES = {
  HOME: '/',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  TERMS_OF_SERVICE: '/terms-of-service',
  
  // API Documentation routes
  API_DOCS: '/api-docs',
  API_DOCS_OVERVIEW: '/api-docs/overview',
  API_DOCS_AUTH: '/api-docs/authentication',
  API_DOCS_SPLITS: '/api-docs/splits',
  API_DOCS_TRANSACTIONS: '/api-docs/transactions',
  API_DOCS_WALLETS: '/api-docs/wallets',
  API_DOCS_ERRORS: '/api-docs/error-codes',
  
  // Help Center routes
  HELP: '/help',
  HELP_GETTING_STARTED: '/help/getting-started',
  HELP_FEATURES: '/help/features',
  HELP_TROUBLESHOOTING: '/help/troubleshooting',
  HELP_ACCOUNT: '/help/account',
  
  NOT_FOUND: '*'
};

/**
 * Helper to generate help article routes
 * @param {string} category - Category name (e.g., 'getting-started')
 * @param {string} article - Article name (e.g., 'welcome')
 * @returns {string} Full route path
 */
export const getHelpArticleRoute = (category, article) => 
  `/help/${category}/${article}`;
